import { useEffect } from 'react';
import { useNavigationPaneContext } from '@website-editor/context/NavigationPaneContext/NavigationPane.context';
import { PHOTO_GALLERY_ANIMATION_CONFIG, PHOTO_GALLERY_SCREENS } from '../PhotoGallery.constants';
import { PhotoGalleryProps } from '../PhotoGallery.types';
import { getPhotoGalleryNavigations } from '../PhotoGallery.navigations';

/**
 * Add photo left panel navigation animation configs
 */
export const useAddPhotoGalleryNavigations = (props: PhotoGalleryProps) => {
  const { screens, addNavigations } = useNavigationPaneContext();
  const photoGalleryNavigations = getPhotoGalleryNavigations({ ...props });
  useEffect(() => {
    if (!screens.includes(PHOTO_GALLERY_SCREENS[0])) {
      addNavigations(PHOTO_GALLERY_SCREENS, PHOTO_GALLERY_ANIMATION_CONFIG, photoGalleryNavigations);
    }
  }, [addNavigations, screens, photoGalleryNavigations]);
};
